module.exports = __webpack_public_path__ + "static/media/img_event4.3de7ec79.png";